import * as store from '@daas-consulting/core-frontend-store';
import { list } from '@daas-consulting/production/age_groups/frontend/models';
import { context, feature } from '../age_groups.const';

const loadItemsActions = store.getActionsNames({
  context,
  feature,
  section: store.SectionsNames.list,
  action: store.ListActionNames.loadItems,
});

export class LoadItems {
  static readonly type = `${loadItemsActions.action}`;
}

export class LoadItemsRequest {
  static readonly type = `${loadItemsActions.request}`;
}

export class LoadItemsSuccessful {
  static readonly type = `${loadItemsActions.successful}`;
  constructor(readonly payload: list.ItemView[]) {}
}

export class LoadItemsFailure {
  static readonly type = `${loadItemsActions.failure}`;
  constructor(readonly payload: Error) {}
}
